import React, { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import SingleToast from '../SingleToast/SingleToast';
import {
	MapToastsCount,
	MapToastsSwiper,
	MapToastsSwiperContainer,
	MapToastsSwiperSlide,
} from '../mapToastsStyles';
import { Place } from '../../../../../models/Place';

type ToastProps = {
	places: Place[];
};

const ClusterToasts: React.FC<ToastProps> = ({ places }) => {
	const [swiper, setSwiper] = useState<any>({});
	const [progress, setProgress] = useState(1);
	const [total, setTotal] = useState(0);
	const handleSlideChange = () => {
		const currentProgress = swiper.realIndex + 1;
		setProgress(currentProgress);
	};

	useEffect(() => {
		setTotal(swiper?.slides?.length);
	}, [swiper.slides]);

	return (
		<MapToastsSwiperContainer>
			<MapToastsCount>
				<p>
					{progress}/{total}
				</p>
			</MapToastsCount>
			<MapToastsSwiper
				// pagination={{
				// 	type: 'fraction',
				// }}
				slidesPerView={'auto'}
				spaceBetween={8}
				onSlideChange={() => handleSlideChange()}
				onSwiper={(swiper) => setSwiper(swiper)}
				// navigation={true}
				// modules={[Pagination, Navigation]}
			>
				{places.map((place) => {
					return (
						<MapToastsSwiperSlide key={place.id}>
							<SingleToast place={place} />
						</MapToastsSwiperSlide>
					);
				})}
			</MapToastsSwiper>
		</MapToastsSwiperContainer>
	);
};

export default ClusterToasts;
